import React from "react";
import { makeStyles, TextField } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    text: {
        fontSize: "14px",
    },
    textField: {
        "& .MuiOutlinedInput-root": {
            borderRadius: "4px !important",
        },
        "& .MuiOutlinedInput-input": {
            padding: "8px",
            background: "#F6F8FA",
            borderRadius: "4px !important",
            height: "22px"
        },
    },
    colorField: {
        "-webkit-appearance": "none",
        border: "none",
        width: "auto",
        height: "auto",
        cursor: "pointer",
        background: "none",
        padding: 0,
        borderRadius: "50%",
        outline: "1px solid #D9D9D9",
        "&::-webkit-color-swatch-wrapper": {
            padding: 0,
            width: 40,
            height: 40,
        },
        "&::-webkit-color-swatch": {
            border: "1px solid #00000020",
            borderRadius: 0,
            padding: 0,
        },
    },
    childrenPadding: {
        "& > *:not(:last-child)": {
            paddingRight: theme.spacing(1), // or any value you want
        },
    },
    justifyEnd:{
        [theme.breakpoints.up("md")]: {
            display: "flex",
            justifyContent: "end",
        }
    },
    container: {
        display: "flex",
        flexDirection: "column",
        width: "fit-content",
    },
}));

const CustomColorPicker = ({ name, label, value, setFieldValue }) => {
    const classes = useStyles();

    function handleChange(e) {
        let input = e.target.value
            .replace(/#/g, "")
            .replace(/[^0-9A-Za-z]/g, "");

        if (input.length > 6) {
            input = input.substring(0, 6);
        }

        setFieldValue(name, "#" + input);
    }

    const displayValue =
        value && value.startsWith("#") ? value.substring(1) : value;

    return (
        <div className={classes.justifyEnd}>
            <div className={classes.container}>
                <span className="mb-2">{label}</span>
                <div
                    className={`d-flex align-items-center ${classes.childrenPadding}`}
                >
                    <span className={classes.text}>#</span>
                    <TextField
                        className={classes.textField}
                        type="text"
                        name={name}
                        value={displayValue}
                        variant="outlined"
                        onChange={(e) => handleChange(e)}
                        InputProps={{
                            style: {
                                width: "70px",
                                fontSize: "14px",
                            },
                        }}
                    />
                    <input
                        type="color"
                        className={classes.colorField}
                        name={name}
                        value={value}
                        onChange={(e) => handleChange(e)}
                    />
                </div>
            </div>
        </div>
    );
};

export default CustomColorPicker;
